import React, { Component } from 'react';
import { LoadingSpinner } from '@paypalcorp/pp-react-loading-spinner';

class Spinner extends Component {
  render() {
    return <LoadingSpinner size="lg" />;
  }
}

export default Spinner;
